import { isMcpTool } from '@kentik/ui-shared/kaizen/constants';
import { getMcpBuiltinServerByToolName } from '@kentik/ui-shared/kaizen/mcpBuiltinServers';

const AGENT_DISPLAY_NAMES = {
  math_agent: 'Math Agent',
  synthetics_agent: 'Synthetics Agent'
};

export function getAgentDisplayName(agentName) {
  if (AGENT_DISPLAY_NAMES[agentName]) {
    return AGENT_DISPLAY_NAMES[agentName];
  }

  const builtin = getMcpBuiltinServerByToolName(agentName);
  if (builtin) {
    return builtin.displayName;
  }

  if (isMcpTool(agentName)) {
    return agentName
      .replace(/^mcp_/, '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  return agentName.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
